export default "__VITE_ASSET__BNJPkTfL__"